import React from 'react';

export const RootPropsContext = React.createContext();
